webpackJsonp([1],{

/***/ 40:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(84)
}
var Component = __webpack_require__(29)(
  /* script */
  __webpack_require__(47),
  /* template */
  __webpack_require__(44),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 42:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 43:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(85)
}
var Component = __webpack_require__(29)(
  /* script */
  __webpack_require__(48),
  /* template */
  __webpack_require__(45),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 44:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('h1', [_vm._v("你可以缩放浏览器试试")]), _vm._v(" "), _c('tree-grid', {
    attrs: {
      "items": _vm.data,
      "columns": _vm.columns
    },
    on: {
      "on-row-click": _vm.rowClick,
      "on-selection-change": _vm.selectionClick,
      "on-sort-change": _vm.sortClick
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 45:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "autoTbale",
    style: ({
      width: _vm.tableWidth
    })
  }, [_c('table', {
    staticClass: "table table-bordered",
    attrs: {
      "id": "hl-tree-table"
    }
  }, [_c('thead', [_c('tr', _vm._l((_vm.cloneColumns), function(column, index) {
    return _c('th', [(column.type === 'selection') ? _c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.checks),
        expression: "checks"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(_vm.checks) ? _vm._i(_vm.checks, null) > -1 : (_vm.checks)
      },
      on: {
        "click": _vm.handleCheckAll,
        "__c": function($event) {
          var $$a = _vm.checks,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.checks = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.checks = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.checks = $$c
          }
        }
      }
    })]) : _c('label', [_vm._v("\n              " + _vm._s(_vm.renderHeader(column, index)) + "\n              "), (column.sortable) ? _c('span', {
      staticClass: "ivu-table-sort"
    }, [_c('Icon', {
      class: {
        on: column._sortType === 'asc'
      },
      attrs: {
        "type": "arrow-up-b"
      },
      nativeOn: {
        "click": function($event) {
          _vm.handleSort(index, 'asc')
        }
      }
    }), _vm._v(" "), _c('Icon', {
      class: {
        on: column._sortType === 'desc'
      },
      attrs: {
        "type": "arrow-down-b"
      },
      nativeOn: {
        "click": function($event) {
          _vm.handleSort(index, 'desc')
        }
      }
    })], 1) : _vm._e()])])
  }))]), _vm._v(" "), _c('tbody', _vm._l((_vm.initItems), function(item, index) {
    return _c('tr', {
      class: {
        'child-tr': item.parent
      }
    }, _vm._l((_vm.columns), function(column, snum) {
      return _c('td', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (_vm.show(item)),
          expression: "show(item)"
        }],
        style: (_vm.tdWidth(column.width))
      }, [(column.type === 'selection') ? _c('label', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.checkGroup),
          expression: "checkGroup"
        }],
        attrs: {
          "type": "checkbox"
        },
        domProps: {
          "value": item.id,
          "checked": Array.isArray(_vm.checkGroup) ? _vm._i(_vm.checkGroup, item.id) > -1 : (_vm.checkGroup)
        },
        on: {
          "__c": function($event) {
            var $$a = _vm.checkGroup,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = item.id,
                $$i = _vm._i($$a, $$v);
              if ($$c) {
                $$i < 0 && (_vm.checkGroup = $$a.concat($$v))
              } else {
                $$i > -1 && (_vm.checkGroup = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
              }
            } else {
              _vm.checkGroup = $$c
            }
          }
        }
      })]) : _vm._e(), _vm._v(" "), (column.type === 'action') ? _c('div', {
        staticClass: "btn_content"
      }, _vm._l(((column.actions)), function(action) {
        return _c('i-button', {
          key: column.text,
          attrs: {
            "type": action.type,
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.RowClick(item, $event, index, action.text)
            }
          }
        }, [_vm._v(_vm._s(action.text))])
      })) : _vm._e(), _vm._v(" "), (!column.type) ? _c('label', {
        on: {
          "click": function($event) {
            _vm.toggle(index, item)
          }
        }
      }, [(snum == 1) ? _c('span', [_c('i', {
        domProps: {
          "innerHTML": _vm._s(item.spaceHtml)
        }
      }), _vm._v(" "), (item.children && item.children.length > 0) ? _c('i', {
        staticClass: "ivu-icon",
        class: {
          'ivu-icon-plus-circled': !item.expanded, 'ivu-icon-minus-circled': item.expanded
        }
      }) : _c('i', {
        staticClass: "ms-tree-space"
      })]) : _vm._e(), _vm._v(" " + _vm._s(_vm.renderBody(item, column)) + "\n          ")]) : _vm._e()])
    }))
  }))])])
},staticRenderFns: []}

/***/ }),

/***/ 47:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_treeGrid2_0__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_treeGrid2_0___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_treeGrid2_0__);
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'app',
    data: function data() {
        return {
            columns: [{
                type: 'selection',
                width: '50'
            }, {
                title: '编码',
                key: 'code',
                sortable: true,
                width: '150'
            }, {
                title: '名称',
                key: 'name',
                width: '150'
            }, {
                title: '状态',
                key: 'status',
                width: '150'
            }, {
                title: '备注',
                key: 'remark',
                width: '150'
            }, {
                title: '操作',
                type: 'action',
                actions: [{
                    type: 'primary',
                    text: '编辑'
                }, {
                    type: 'error',
                    text: '删除'
                }],
                width: '150'
            }],
            data: [{
                id: '1',
                code: '0001',
                name: '测试数据1',
                status: '启用',
                remark: '测试数据测试数据',
                _checked: true
            }, {
                id: '2',
                code: '0002',
                name: '测试数据2',
                status: '启用',
                remark: '测试数据测试数据',
                children: [{
                    id: '21',
                    code: '00001',
                    name: '测试数据01',
                    status: '启用',
                    remark: '测试数据测试数据'
                }, {
                    id: '22',
                    code: '00002',
                    name: '测试数据02',
                    status: '启用',
                    remark: '测试数据测试数据',
                    children: [{
                        id: '221',
                        code: '000001',
                        name: '测试数据001',
                        status: '启用',
                        remark: '测试数据测试数据'
                    }]
                }]
            }, {
                id: '3',
                code: '0003',
                name: '测试数据3',
                status: '启用',
                remark: '测试数据测试数据'
            }, {
                id: '4',
                code: '0004',
                name: '测试数据4',
                status: '启用',
                remark: '测试数据测试数据'
            }]
        };
    },

    components: {
        treeGrid: __WEBPACK_IMPORTED_MODULE_0__components_treeGrid2_0___default.a
    },
    methods: {
        rowClick: function rowClick(data, index, event) {
            console.log('当前行数据:' + data);
            console.log('点击行号:' + index);
            console.log('点击事件:' + event);
        },
        selectionClick: function selectionClick(arr) {
            console.log('选中数据id数组:' + arr);
        },
        sortClick: function sortClick(key, type) {
            console.log('排序字段:' + key);
            console.log('排序规则:' + type);
        }
    }
});

/***/ }),

/***/ 48:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(15);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'treeGrid',
  props: {
    columns: Array,
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      initItems: [], //处理后数据数组
      cloneColumns: [], //处理后的表头数据
      checkGroup: [], //复选框数组
      checks: false, //全选
      screenWidth: document.body.clientWidth, //自适应宽
      tdsWidth: 0, //td总宽
      timer: false, //控制监听时长
      dataLength: 0 //树形数据长度
    };
  },

  computed: {
    tableWidth: function tableWidth() {
      return this.tdsWidth > this.screenWidth && this.screenWidth > 0 ? this.screenWidth + 'px' : '100%';
    }
  },
  watch: {
    screenWidth: function screenWidth(val) {
      var _this = this;

      if (!this.timer) {
        this.screenWidth = val;
        this.timer = true;
        setTimeout(function () {
          _this.timer = false;
        }, 400);
      }
    },
    items: function items() {
      if (this.items) {
        this.dataLength = this.Length(this.items);
        this.initData(this.deepCopy(this.items), 1, null);
        this.checkGroup = this.renderCheck(this.items);
        if (this.checkGroup.length == this.dataLength) {
          this.checks = true;
        } else {
          this.checks = false;
        }
      }
    },

    columns: {
      handler: function handler() {
        this.cloneColumns = this.makeColumns();
      },

      deep: true
    },
    checkGroup: function checkGroup(data) {
      this.checkAllGroupChange(data);
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    if (this.items) {
      this.dataLength = this.Length(this.items);
      this.initData(this.deepCopy(this.items), 1, null);
      this.cloneColumns = this.makeColumns();
      this.checkGroup = this.renderCheck(this.items);
      if (this.checkGroup.length == this.dataLength) {
        this.checks = true;
      } else {
        this.checks = false;
      }
    }
    // 绑定onresize事件 监听屏幕变化设置宽
    this.$nextTick(function () {
      _this2.screenWidth = document.body.clientWidth;
    });
    window.onresize = function () {
      return function () {
        window.screenWidth = document.body.clientWidth;
        _this2.screenWidth = window.screenWidth;
      }();
    };
  },

  methods: {
    // 设置td宽度
    tdWidth: function tdWidth(val) {
      if (val) return {
        'min-width': val + 'px'
      };
    },

    // 排序事件
    handleSort: function handleSort(index, type) {
      this.cloneColumns.forEach(function (col) {
        return col._sortType = 'normal';
      });
      if (this.cloneColumns[index]._sortType === type) {
        this.cloneColumns[index]._sortType = 'normal';
      } else {
        this.cloneColumns[index]._sortType = type;
      }
      this.$emit('on-sort-change', this.cloneColumns[index]['key'], this.cloneColumns[index]['_sortType']);
    },

    // 点击某一行事件
    RowClick: function RowClick(data, event, index, text) {
      var result = this.makeData(data);
      this.$emit('on-row-click', result, event, index, text);
    },

    // 点击事件 返回数据处理
    makeData: function makeData(data) {
      var t = typeof data === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(data);
      var o = void 0;
      if (t === 'array') {
        o = [];
      } else if (t === 'object') {
        o = {};
      } else {
        return data;
      }

      if (t === 'array') {
        for (var i = 0; i < data.length; i++) {
          o.push(this.makeData(data[i]));
        }
      } else if (t === 'object') {
        for (var _i in data) {
          if (_i != 'spaceHtml' && _i != 'parent' && _i != 'level' && _i != 'expanded' && _i != 'isShow' && _i != 'load') {
            o[_i] = this.makeData(data[_i]);
          }
        }
      }
      return o;
    },

    // 处理表头数据
    makeColumns: function makeColumns() {
      var _this3 = this;

      var columns = this.deepCopy(this.columns);
      this.tdsWidth = 0;
      columns.forEach(function (column, index) {
        column._index = index;
        column._width = column.width ? column.width : '';
        column._sortType = 'normal';
        _this3.tdsWidth += column.width ? parseFloat(column.width) : 0;
      });
      return columns;
    },

    // 数据处理 增加自定义属性监听
    initData: function initData(items, level, parent) {
      var _this4 = this;

      this.initItems = [];
      var spaceHtml = "";
      for (var i = 1; i < level; i++) {
        spaceHtml += "<i class='ms-tree-space'></i>";
      }
      items.forEach(function (item, index) {
        item = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, item, {
          "parent": parent,
          "level": level,
          "spaceHtml": spaceHtml
        });
        if (typeof item.expanded == "undefined") {
          item = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, item, {
            "expanded": false
          });
        }
        if (typeof item.show == "undefined") {
          item = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, item, {
            "isShow": false
          });
        }
        item = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, item, {
          "load": item.expanded ? true : false
        });
        _this4.initItems.push(item);
        if (item.children && item.expanded) {
          _this4.initData(item.children, level + 1, item);
        }
      });
    },

    //  隐藏显示
    show: function show(item) {
      return item.level == 1 || item.parent && item.parent.expanded && item.isShow;
    },
    toggle: function toggle(index, item) {
      var _this5 = this;

      var level = item.level + 1;
      var spaceHtml = "";
      for (var i = 1; i < level; i++) {
        spaceHtml += "<i class='ms-tree-space'></i>";
      }
      if (item.children) {
        if (item.expanded) {
          item.expanded = !item.expanded;
          this.close(index, item);
        } else {
          item.expanded = !item.expanded;
          if (item.load) {
            this.open(index, item);
          } else {
            item.load = true;
            item.children.forEach(function (child, childIndex) {
              _this5.initItems.splice(index + childIndex + 1, 0, child);
              //设置监听属性
              __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(_this5.initItems[index + childIndex + 1], 'parent', item);
              __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(_this5.initItems[index + childIndex + 1], 'level', level);
              __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(_this5.initItems[index + childIndex + 1], 'spaceHtml', spaceHtml);
              __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(_this5.initItems[index + childIndex + 1], 'isShow', true);
              __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(_this5.initItems[index + childIndex + 1], 'expanded', false);
            });
          }
        }
      }
    },
    open: function open(index, item) {
      var _this6 = this;

      if (item.children) {
        item.children.forEach(function (child, childIndex) {
          child.isShow = true;
          if (child.children && child.expanded) {
            _this6.open(index + childIndex + 1, child);
          }
        });
      }
    },
    close: function close(index, item) {
      var _this7 = this;

      if (item.children) {
        item.children.forEach(function (child, childIndex) {
          child.isShow = false;
          if (child.children) {
            _this7.close(index + childIndex + 1, child);
          }
        });
      }
    },

    //checkbox 全选 选择事件
    handleCheckAll: function handleCheckAll() {
      if (this.checks) {
        this.checkGroup = this.getArray(this.checkGroup.concat(this.All(this.items)));
      } else {
        this.checkGroup = [];
      }
      // this.$emit('on-selection-change', this.checkGroup)
    },

    // 数组去重
    getArray: function getArray(a) {
      var hash = {},
          len = a.length,
          result = [];
      for (var i = 0; i < len; i++) {
        if (!hash[a[i]]) {
          hash[a[i]] = true;
          result.push(a[i]);
        }
      }
      return result;
    },
    checkAllGroupChange: function checkAllGroupChange(data) {
      if (data.length === this.dataLength) {
        this.checks = true;
      } else {
        this.checks = false;
      }
      this.$emit('on-selection-change', this.checkGroup);
    },
    All: function All(data) {
      var _this8 = this;

      var arr = [];
      data.forEach(function (item) {
        arr.push(item.id);
        if (item.children && item.children.length > 0) {
          arr = arr.concat(_this8.All(item.children));
        }
      });
      return arr;
    },

    // 返回树形数据长度
    Length: function Length(data) {
      var _this9 = this;

      var length = data.length;
      data.forEach(function (child) {
        if (child.children) {
          length += _this9.Length(child.children);
        }
      });
      return length;
    },

    // 返回表头
    renderHeader: function renderHeader(column, $index) {
      if ('renderHeader' in this.columns[$index]) {
        return this.columns[$index].renderHeader(column, $index);
      } else {
        return column.title || '#';
      }
    },


    // 返回内容
    renderBody: function renderBody(row, column, index) {
      return row[column.key];
    },

    // 默认选中
    renderCheck: function renderCheck(data) {
      var _this10 = this;

      var arr = [];
      data.forEach(function (item) {
        if (item._checked) {
          arr.push(item.id);
        }
        if (item.children && item.children.length > 0) {
          arr = arr.concat(_this10.renderCheck(item.children));
        }
      });
      return arr;
    },

    // 深度拷贝函数
    deepCopy: function deepCopy(data) {
      var t = this.type(data),
          o,
          i,
          ni;
      if (t === 'array') {
        o = [];
      } else if (t === 'object') {
        o = {};
      } else {
        return data;
      }
      if (t === 'array') {
        for (i = 0, ni = data.length; i < ni; i++) {
          o.push(this.deepCopy(data[i]));
        }
        return o;
      } else if (t === 'object') {
        for (i in data) {
          o[i] = this.deepCopy(data[i]);
        }
        return o;
      }
    },
    type: function type(obj) {
      var toString = Object.prototype.toString;
      var map = {
        '[object Boolean]': 'boolean',
        '[object Number]': 'number',
        '[object String]': 'string',
        '[object Function]': 'function',
        '[object Array]': 'array',
        '[object Date]': 'date',
        '[object RegExp]': 'regExp',
        '[object Undefined]': 'undefined',
        '[object Null]': 'null',
        '[object Object]': 'object'
      };
      return map[toString.call(obj)];
    }
  },
  beforeDestroy: function beforeDestroy() {
    window.onresize = null;
  }
});

/***/ }),

/***/ 49:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_iview__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_iview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_iview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_iview_dist_styles_iview_css__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_iview_dist_styles_iview_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_iview_dist_styles_iview_css__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.






__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_iview___default.a);
/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  template: '<App/>',
  components: {
    App: __WEBPACK_IMPORTED_MODULE_1__App___default.a
  }
});

/***/ }),

/***/ 84:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 85:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[49]);


// WEBPACK FOOTER //
// static/js/app.8356f189b292f9bfc707.js